import { diInject, diRegister } from 'stores/diContext';
import { OrderStore } from "../stores/order";
import {isMaxCharacter, requiredStringOrArray} from "./_validator";
import { observable, action, toJS } from 'mobx';
import * as _ from "lodash";
import { FieldState, FormState } from 'formstate/src';
import { QuestionType } from "consts/QuestionType";
import { EventStore } from "Apps/ticketing/stores/events";
type AnswerState = FieldState<any>;

export class QuestionState {
    constructor(public question) {
        var initValue = question.display_type == QuestionType.TextBox ? '' : []
        let validators = [];
        if (question.is_required) {
            validators = [requiredStringOrArray(),isMaxCharacter(256)];
        }
        this.answers = new FieldState(initValue).validators(...validators);
    }
    id = this.question.id;
    label = this.question.text;
    type=this.question.display_type;
    extra = this.question.options;
    answers: AnswerState;
    validate() {
        return this.answers.validate();
    }
}

export default class QuestionForm  {
    @diInject() eventStore: EventStore;

    questions = observable.map<QuestionState>();

    private last_keys = {};

    createFields(questions) {
        const { event: { is_set_addtional_info } } = this.eventStore;
        if (is_set_addtional_info) {
            var newKeys: { [key: string]: any } = {};
            for (let question of questions) {
                const key = `${question.id}`;
                if (!this.questions.has(key)) {
                    var qState = new QuestionState(question)
                    this.questions.set(key, qState);
                }
                this.last_keys[key] = newKeys[key] = true;
            }
            for (let key in this.last_keys) {
                //删除不在新问题列表中的field
                if (!newKeys[key]) {
                    this.questions.delete(key);
                }
            }
        }
    }

    removeAll() {
        this.last_keys = {};
        this.questions.clear();
    }
    values() {
        return this.questions.values().map(qa => {
            var answers = toJS(qa.answers.$);
            return {
                id: qa.id,
                answers: _.isArray(answers) ? answers : [answers]
            }
        });
    }
    async validate() {
        var questions = this.getCurrentFields();
        var hasError = false;
        var tasks = [];
        for (var q of questions) {
            var task = q.validate();
            tasks.push(task);
        }
        var results = await Promise.all(tasks);
        hasError = results.find(r => r.hasError) != null;
        return { hasError };
    }

    getCurrentFields() {
        var fields=this.questions.values();
        //对问题排序
        fields.sort((a,b)=>{
            return a.question.placement_index-b.question.placement_index;
        });
        return fields;
    }

    static create() {
        var d = new QuestionForm();
        return d;
    }
}



// WEBPACK FOOTER //
// ./src/Apps/ticketing/forms/question.ts